import type { ReactNode } from 'react'
import { cn } from '@/shared/lib'
import { parseHighlight } from './parse'

interface SnippetProps {
  text: string
  className?: string
}

// Фрагмент выдачи поиска с подсветкой совпадения. Подсветка — тихий warning-фон
// (не accent: docs/design/screens/search.md §Микро). Ключи — по смещению символа
// (сегменты статичны, но так без индекс-ключа).
export function Snippet({ text, className }: SnippetProps) {
  const nodes: ReactNode[] = []
  let offset = 0
  for (const part of parseHighlight(text)) {
    const key = `${offset}`
    offset += part.text.length
    nodes.push(
      part.mark ? (
        <mark key={key} className="rounded-[3px] bg-warning/15 px-0.5 text-text-secondary">
          {part.text}
        </mark>
      ) : (
        <span key={key}>{part.text}</span>
      ),
    )
  }
  return <span className={cn('text-text-tertiary', className)}>{nodes}</span>
}
